<template>
  <Header />
  <div class="wrapper">
    <router-view v-if="!isLoading" />
    <Loader v-else class="loader-default" />
  </div>
  <div id="modals"></div>
  <Error v-if="error" />
  <ModalSuccess v-if="success" />
  <TwoFactorNotification />
</template>

<script setup>
import Error from '@/components/Error.vue'
import Header from '@/components/Header.vue'
import ModalSuccess from '@/components/ModalSuccess.vue'
import Loader from '@/components/Loader.vue'
import { getToken } from '@/utils/cookie'
import useResources from '@/utils/useResources'
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import TwoFactorNotification from '@/components/TwoFactorNotification.vue'

const token = getToken()
const store = useStore()
const error = computed(() => store.state.error)
const success = computed(() => store.state.success)
const isLoading = computed(() => token && !store.state.auth.me)

onMounted(async () => {
  // загружаем ресурсы
  if (getToken()) {
    const { loadResources } = useResources()
    await loadResources()
  }
})
</script>

<style lang="scss">
.wrapper {
  padding-top: 40px;
  padding-bottom: 40px;
  @include mobile {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  &__loader {
    display: flex;
    margin: 0 auto;
    max-height: 200px;
  }
}
</style>
